module.exports = __webpack_public_path__ + "img/historial-dental.57c4d3ae.png";